/**
 * Removes all elements from an array that satisfy a predicate.
 * @util
 *
 * @template T - The type of elements in the array
 * @param array - The array to remove elements from
 * @param predicate - Function that determines if an element should be removed
 * @returns The number of elements removed
 */
export function arrayRemoveWhere(array, predicate) {
    let count = 0;
    for (let i = 0; i < array.length; i++) {
        if (predicate(array[i])) {
            array.splice(i, 1);
            i--;
            count++;
        }
    }
    return count;
}
//# sourceMappingURL=arrayRemoveWhere.js.map